import React, { useState } from "react";
import { RiCoupon2Line } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import { BsEmojiSmile } from "react-icons/bs";
import { CouponDialog } from "../components/Model";

export default function Success() {
  const [open, setOpen] = useState(true);
  const [isCoupon, setIsCoupon] = useState("");

  const prize = Number(localStorage.getItem("reward"));
  const navigate = useNavigate();

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <>
      {open && prize > 0 && (
        <CouponDialog handleClose={handleClose} setIsCoupon={setIsCoupon} />
      )}
      <div className="spin-offer-container">
        <div className="offer-message">
          {prize === 0 && (
            <>
              <h1>Oops you got 0%</h1>
              <p>Better luck next time</p>
              <button onClick={() => navigate("/spin")} className="coupon-btn">
                Spin Again
              </button>
            </>
          )}
          {!open && isCoupon && (
            <>
              <BsEmojiSmile size={70} className="coupon-icon" />
              <h1>Take {prize}% off</h1>
              <p>
                Don't miss the chance and get your {prize}% off on your next
                order
              </p>
              <span className="coupon-bg">{isCoupon}</span>
              <button onClick={() => navigate("/spin")} className="coupon-btn">
                Spin Again
              </button>
            </>
          )}
          {!open && prize > 0 && !isCoupon && (
            <>
              <RiCoupon2Line size={70} className="coupon-icon" />
              <h2>Click to win Coupon</h2>
              <button onClick={handleClickOpen} className="coupon-btn">
                Generate Coupon
              </button>
            </>
          )}
        </div>
      </div>
    </>
  );
}
